import { HttpStatus } from '../constants';

export type IResponseError = {
  code: string;
  data: null;
  message: string;
  message_detail: string | null;
  success: false;
};

export class ResponseError extends Error implements IResponseError {
  // Client error codes
  static readonly CLIENT_ERROR = 'CLIENT_ERROR';
  static readonly CONFLICT = 'CONFLICT';
  static readonly CONFLICT_ERROR = 'CONFLICT_ERROR';

  static readonly CREATED = 'CREATED';
  static readonly DRAFT_NOT_FOUND = 'DRAFT_NOT_FOUND';
  static readonly FORBIDDEN = 'FORBIDDEN';
  static readonly INTERNAL_ERROR = 'INTERNAL_ERROR';
  // Server error codes
  static readonly INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR';
  static readonly NO_ACCESS = 'NO_ACCESS';
  static readonly NOT_FOUND = 'NOT_FOUND';
  // Specific business error codes
  static readonly OAUTH_ERROR = 'OAUTH_ERROR';
  // Success codes
  static readonly OK = 'OK';
  static readonly SUCCESS = 'SUCCESS';

  static readonly UNAUTHORIZED = 'UNAUTHORIZED';
  static readonly UNPROCESSABLE_ENTITY = 'UNPROCESSABLE_ENTITY';

  static readonly VALIDATION_ERROR = 'VALIDATION_ERROR';

  code: string;
  data: null;
  httpStatus: number;
  message: string;
  message_detail: string | null;
  success = false as const;

  constructor(
    httpStatus: number = HttpStatus.INTERNAL_SERVER_ERROR,
    code: string = ResponseError.INTERNAL_SERVER_ERROR,
    message: string = 'Server error',
    message_detail: string | null = null,
    data: null = null,
  ) {
    super(message);

    this.httpStatus = httpStatus;
    this.code = code;
    this.message = message;
    this.message_detail = message_detail;
    this.data = data;
    this.success = false;
  }
}

export const isResponseError = (error: unknown): error is ResponseError => error instanceof ResponseError;
